// extracted by mini-css-extract-plugin
export default {"dotMenu":"ParticipantDotMenu_dotMenu__j1PUm"};